import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Eier extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleEier = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateEier = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Eier",
            eier: this.props.eier
        })
    }

    render() {
        const { t } = this.props        
        var eier = this.props.eier
        var navn = !eier.eierId && eier.matrikkelnummer != null ? t('seeiendematrikkelenhet') : eier.navn
        var andel = !eier.matrikkelnummer && eier.nevner > 0 ? ` - ${eier.teller}/${eier.nevner}` : eier.matrikkelnummer ? ` - (${eier.matrikkelnummer})` : "";
        var eierforholdKode = eier.EierforholdKodeEiendeMatrikkelenhet || eier.eierforholdKode;
        var rolle = eierforholdKode ? eierforholdKode.substr(0, eierforholdKode.indexOf(' ')) : "";
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleEier}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{navn} - {rolle}{andel}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    { eier.eierId > 0 &&
                    <div className="icon-image right tooltip" onClick={this.navigateEier}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.eier')}</div>
                    </div> }
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('navn')}</div>
                            <div className="value">{navn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{ eier.domeneklasse == "JuridiskPerson" ? t('orgnummer') : t('fodselsnummer')}</div>
                            <div className="value">{eier.nummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('adresse')}</div>
                            <div className="value">{eier.postadresselinje2 || eier.postadresselinje1}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('poststed')}</div>
                            <div className="value">{eier.postadresselinje3}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('rolle')}</div>
                            <div className="value">{eier.eierforholdKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{ eier.matrikkelnummer ? t('andeleier') : t('andel')}</div>
                            <div className="value">{eier.teller}/{eier.nevner}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('personkategori')}</div>
                            <div className="value">{eier.personkategoriKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('personstatus')}</div>
                            <div className="value">{eier.personstatusKode}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('datofra')}</div>
                            <div className="value"><Moment local>{eier.datoFra}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('andelsnummer')}</div>
                            <div className="value">{eier.andelsnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                    { eier.matrikkelnummer && <div className="column">
                            <div className="label">{t('personeierforholdtinglyst')}</div>
                            <div className="value">{eier.personEierforholdTinglyst ? "Ja" : "Nei"}</div>
                        </div> }
                        <div className="column">
                            <div className="label">{t('matrikkelenheteierforholdtinglyst')}</div>
                            <div className="value">{eier.matrikkelenhetEierforholdTinglyst ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    { eier.matrikkelnummer &&
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('eiendematrikkelnummer')}</div>
                            <div className="value">{eier.matrikkelnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{ t('andelperson')}</div>
                            <div className="value">{eier.tellerEier}/{eier.nevnerEier}</div>
                        </div>
                    </div> }
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Eier)